module.exports = __webpack_public_path__ + "static/gosugam-links-0220b965fd92706bc523648fb413fa89.jpeg";